import React, { useState, useEffect } from "react";
import FrontPage from "./frontPage";
import BackPage from "./backPage";
import LeftAndRightPages from "./leftAndRightPages";
import axios from "axios";
// import minionsImg from '../images/minions.png'
import katMeme from '../images/katMeme.jpg'
import flapGif from '../images/flapGif.gif'
import borty from '../images/borty.jpeg'
import friendMovie from '../videos/friend.mov'

const BirthdayCard = ({ onCardVideoPlaybackChange }) => {
  const [gifs, setGifs] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    return () => {
      onCardVideoPlaybackChange?.(false);
    };
  }, [currentPage, onCardVideoPlaybackChange]);

  const wishes = [
    { comment: "Happy 32nd Birthday, Keefler! 🎉", imageSrc: null },
    {
      name: "kat",
      comment:
        "happy birthday to my absolute favorite pink-obsessed musician!!!!! I’m literally too boiled to think of something clever to say and I feel like you would understand, so thanks. love you, friend!!",
        imageSrc: katMeme
    },
    {
      name: "Grantito",
      comment:
        "happy birthday to the chillest chiller on the planet (you you you you you). thanks so much for bringing the elfitos together! griddyGoose keefleKEEF",
        imageSrc: null
    },
    {
      name: "Amanda",
      comment:
        "Happy 32nd birthday!! I really appreciate all the chill streams. They’ve honestly made my days feel significantly chiller, so thank you for that. Not to get too Jimmy Neutron about it but I’m pretty sure you cracked the code on the perfect chill vibe. Like this is a full on brain blast level achievement. Hope your day is super fun and easygoing, you deserve it keefleSLAY",
        imageSrc: null
    },
    {
      name: "Sarah",
      comment: "A very chill happy birthday to the pinkest guy.",
      imageSrc: null,
      videoSrc: friendMovie,
    },
    {
      name: "Ruston",
      comment:
        "You think you're so special just because you're celebrating your birthday? Well guess what, I've already been doing that all day too. So ha! Hope we get to celebrate in person with a sixth ring on our hands chiefus Keefus, love you to the Sun and back!",
        imageSrc: null
    },
    {
      name: "meg",
      comment:
        "Wow it's been 32 years since they made you in a lab to be the chillest guy ever! 32 is a great number, much better than ....31 .....Happy Bort-day!",
        imageSrc: borty
    },
    {
      name: "flapjack",
      comment:
        "happy birthday keef!!! here's to another chill year",
        imageSrc: flapGif
    },
    {
      name: "Zombie",
      comment:
        "Happy birthday keef!! I know it says there's 7 people before me but actually I was first. I hope you have an amazing day and hope you know that you've created a really wonderful community! The Elves are singlehandedly my favorite community ever and a large part of that is because of your chill vibe. Enjoy your birthday, Captain Chill 🫡",
        imageSrc: null
    },
    {
      name: "Javo",
      comment:
        "Keef! Have an amazing 32nd Birthday full of chill and pink! Here's to another great(er) year for you! ",
        imageSrc: null
    },
    {
      name: "Molly",
      comment:
        "KEEF! I can't believe it's already your birthday. I wish you the chillest and papoyest birthday EVER. No one can chill as hard as you (maybe Wemby), but that's open for discussion. Enjoy your day king!!!! Love you so much!",
        imageSrc: null
    },
    {
      name: "Maya aka yourfavemod",
      comment:
        "Happy birthday, b'ef! Congratulations on another trip around the sun ☀️ Thank you for this wonderful community. I hope it is evident that we love you very much. Wishing you the best, this year and always patrickCheer 💜",
        imageSrc: null
    },
    {
      name: "Turbo",
      comment:
        "Bro, merry bornday, imagine being old",
        imageSrc: null
    }
  ];

  useEffect(() => {
    axios
      .get(
        `https://api.giphy.com/v1/gifs/search?api_key=${process.env.REACT_APP_GIPHY_API_KEY}&limit=50&q=420`
      )
      .then((response) => {
        setGifs(
          response.data.data
            .filter((g) => !["elon", "trump"].includes(g.title.toLowerCase()))
            .sort((a, b) => Math.random() - Math.random())
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  let pageToShow = <FrontPage />;
  if (currentPage === 0) {
    pageToShow = <FrontPage wish={wishes[currentPage]} />;
  } else if (currentPage > 0 && currentPage < wishes.length) {
    pageToShow = (
      <LeftAndRightPages
        wish={wishes[currentPage]}
        gif={gifs[currentPage]}
        currentPage={currentPage}
        onCardVideoPlaybackChange={onCardVideoPlaybackChange}
      />
    );
  } else {
    pageToShow = <BackPage wish={wishes[currentPage]} />;
  }

  const decrementPage = () => {
    const newPageNum = currentPage - 1;
    if (newPageNum >= 0) {
      setCurrentPage(newPageNum);
    }
  };

  const incrementPage = () => {
    const newPageNum = currentPage + 1;
    if (newPageNum <= wishes.length) {
      setCurrentPage(newPageNum);
    }
  };

  return (
    <div className="birthday-card">
      {pageToShow}
      <div className="controls">
        <div onClick={decrementPage}>{currentPage > 0 ? "⬅️" : null}</div>
        <div onClick={incrementPage}>
          {currentPage < wishes?.length ? "➡️" : null}
        </div>
      </div>
    </div>
  );
};

export default BirthdayCard;
